"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DeleteButton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _ConfirmActionButton = _interopRequireDefault(require("./ConfirmActionButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function DeleteButton(_ref) {
  var context = _ref.context,
    onClick = _ref.onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/_react.default.createElement(_ConfirmActionButton.default, {
    title: "Delete ".concat(context),
    confirmationMessage: "Are you sure you want to delete this ".concat(context, "?"),
    onAction: onClick,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_Delete.default, null));
}
DeleteButton.defaultProps = {
  disabled: false
};
DeleteButton.propTypes = {
  context: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool
};